import React, { Component } from 'react';
import styled from 'styled-components';
import accords from './accords';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  setCurrentSelection,
  getCurrentSelection,
  importImage,
  initPlayer,
  getUpholstery,
  clearSelection,
} from '../modules/player';

import {
  getActiveImageAssets,
  getActiveAddionalAttributes,
  shareOrder,
  setShareState,
} from '../modules/products';

const Accordion = styled.div`
  width: 30%;
  //margin-top: 30px;
  border-top: 1px solid #cccccc;

  dl {
    margin: 0 auto 45px;
  }

  dl dt {
    border-bottom: 1px solid #cccccc;
    color: #000;
    cursor: pointer;
    font-family: HelveticaNeueLTPro-Bd;
    font-size: 13px;
    font-weight: normal;
    line-height: 16px;
    padding: 18px 27px 13px 0;
    position: relative;
    text-transform: uppercase;
    padding-right: 0px;
  }

  dl dt.open {
    padding-right: 0px;
  }

  dl dt:before {
    background-image: url(/img/arrow-up.png);
    width: 16px;
    height: 8px;
    background-position: 0px 0px;
    background-repeat: no-repeat;
    content: '';
    right: 0px;
    top: 20px;
    position: absolute;
  }

  dl dt.open:before {
    background-image: url(/img/arrow-down.png);
    width: 16px;
    height: 8px;
    background-position: 0px 0px;
  }

  dl dd {
    color: #4a4642;
    font-size: 13px;
    line-height: 16px;
    margin: 0;
    padding: 0;
  }

  dl dd.open {
    max-height: 675px;
    height: auto;
    transition: max-height 1s;
    animation: 2s delay-overflow;
    -webkit-animation: 2s delay-overflow;
  }

  @keyframes delay-overflow {
    from {
      overflow: hidden;
    }
    to {
      overflow: visible;
    }
  }

  @-webkit-keyframes delay-overflow {
    from {
      overflow: hidden;
    }
    to {
      overflow: visible;
    }
  }
  dl dd.closed {
    max-height: 0px;
    transition: max-height 1s;
    overflow: hidden;
  }

  dl dd .sub-content {
    padding: 20px 0 27px 0;
  }

  dl dd .sub-content:after {
    content: 0020;
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }
`;

const NextButton = styled.button`
  width: 100%;
  text-align: center;
  height: 36px;
  margin: 10px auto;
  border: 1px solid #8c8783;
  outline: 0;
  color: #7d7773;
  background-color: transparent;
  display: inline-block;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 13px;
  line-height: 36px;
  padding: 0 20px;
  cursor: pointer;
  text-transform: uppercase;
  :hover {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :focus {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
  :active {
    border: 1px solid #5bb9ef;
    color: #5bb9ef;
  }
`;

class Configurator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIdx: 0,
    };
  }

  changeActiveTab(idx, e) {
    e.stopPropagation();
    const { initialized, initPlayer, clearSelection } = this.props;
    const { activeIdx } = this.state;
    if (!initialized || activeIdx === 0) initPlayer(true);
    if (idx !== 0) {
      clearSelection(false);
    }
    this.setState({ activeIdx: idx });
  }
  componentWillReceiveProps(props, nextProps) {
    const { showPresets } = props;
    if (showPresets) {
      this.setState({ activeIdx: 0 });
    }
  }

  render() {
    const sections = [
      { label: 'GET STARTED', key: 'GetStart' },
      { label: 'UPHOLSTERY', key: 'Upholstery' },
      { label: 'FRAME FINISHES', key: 'FrameFinish' },
      { label: 'ADDITIONAL FEATURES', key: 'AddionalFeatures' },
      { label: 'SHARE', key: 'Share' },
    ];
    const { activeIdx } = this.state;
    const {
      currentSelection,
      setCurrentSelection,
      importImage,
      activeImages,
      addtionalAttributes,
      shareOrder,
      initialized,
      upholstery,
      showPresets,
      shareState,
      setShareState,
    } = this.props;
    const childLength = sections.length;
    const activeKey = sections[activeIdx].key;
    const ActiveContainer = accords[activeKey];
    return (
      <Accordion>
        <dl>
          {sections.map((section, idx) => {
            const Content = accords[section.key];
            return (
              <div key={section.key}>
                <dt
                  className={activeIdx === idx ? 'open' : ''}
                  onClick={
                    activeIdx !== idx
                      ? this.changeActiveTab.bind(this, idx)
                      : () => {}
                  }
                >
                  {section.label}
                  <dd className={activeIdx === idx ? 'open' : 'closed'}>
                    <Content
                      images={
                        activeImages &&
                        (section.key === 'FrameFinish'
                          ? Object.assign(
                              {},
                              {
                                base: activeImages[section.key],
                                premium: activeImages['PremiumOptions'],
                              }
                            )
                          : activeImages[section.key])
                      }
                      importImage={importImage}
                      upholstery={upholstery}
                      currentSelection={currentSelection}
                      setCurrentSelection={setCurrentSelection}
                      addtionalAttributes={addtionalAttributes}
                      shareOrder={shareOrder}
                      shareState={shareState}
                      setShareState={setShareState}
                    />
                    {idx < childLength - 1 && (
                      <NextButton
                        onClick={this.changeActiveTab.bind(this, idx + 1)}
                      >
                        NEXT
                      </NextButton>
                    )}
                  </dd>
                </dt>{' '}
              </div>
            );
          })}
        </dl>
      </Accordion>
    );
  }
}

const mapStateToProps = state => ({
  currentSelection: getCurrentSelection(state),
  activeImages: getActiveImageAssets(state),
  addtionalAttributes: getActiveAddionalAttributes(state),
  initialized: state.player.initialized,
  upholstery: getUpholstery(state),
  showPresets: state.player.showPresets,
  shareState: state.products.shareState,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setCurrentSelection,
      importImage,
      shareOrder,
      initPlayer,
      setShareState,
      clearSelection,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Configurator);



// WEBPACK FOOTER //
// ./src/components/Configurator.js